export enum RecipeNotificationResultType {
  Success = 1,
  Failed = 2,
  Pending = 3,
  Enqueued = 4,
  Processing = 5
}